import * as React from 'react';
import { graphql, PageProps } from 'gatsby';
import BookingPage from 'booking/components/BookingPage';
import type {
    BookingPageContext,
    BookingPageWithLocationQuery,
} from 'booking/lib/types';
import DateForm from 'booking/components/DateForm';
import { combinePageMetaDataFragments } from 'booking/lib/utils';

export const query = graphql`
    fragment BookingPageWithLocationQuery on Query {
        ...OgImageQuery
        bookingPage: page(slug: { eq: "booking" }) {
            ...PageMetaData
        }
        dateBookingPage: page(slug: { eq: "booking/date" }) {
            ...PageMetaData
        }
        stepBookingPage: page(slug: { eq: $stepSlug }) {
            ...PageMetaData
        }
        homePage: page(slug: { eq: "home" }) {
            ...PageMetaData
        }
        city(slug: { eq: $citySlug }) {
            label
        }
        location(shortSlug: { eq: $shortSlug }) {
            ...LocationData
        }
    }
    query BookingDatePageQuery(
        $shortSlug: String!
        $citySlug: String!
        $stepSlug: String!
        $ogImage: String
    ) {
        ...BookingPageWithLocationQuery
    }
`;

export default function BookingDatePage({
    path,
    data: {
        ogImage,
        homePage,
        bookingPage,
        dateBookingPage,
        stepBookingPage,
        location,
        city,
    },
    pageContext: { citySlug, shortSlug },
}: PageProps<BookingPageWithLocationQuery, BookingPageContext>) {
    const page = React.useMemo(
        () =>
            combinePageMetaDataFragments(
                [homePage, bookingPage, dateBookingPage, stepBookingPage],
                city.label,
                location.name,
            ),
        [
            city.label,
            location.name,
            homePage,
            bookingPage,
            dateBookingPage,
            stepBookingPage,
        ],
    );

    return (
        <BookingPage
            citySlug={citySlug}
            locationSlug={shortSlug}
            step={'date'}
            page={page}
            pathname={path}
            ogImage={ogImage}
            location={location}
        >
            <DateForm location={location} />
        </BookingPage>
    );
}
